module.exports = __webpack_public_path__ + "static/media/christian.9fcea740.jpg";